import { RemoteResult, IdRequest, FilialeInfo, LoadState } from "mangdto"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import BaseLogic from "../base_logic"

export default class FilialeInfoLogic extends BaseLogic {
  filialeInfo: FilialeInfo = null
  infoLoadState: LoadState = LoadState.Idle

  init() {
    this.infoLoadState = LoadState.Loading

    var request = new IdRequest()
    request.id = this.filiale.filialeId

    Poster.postUser<RemoteResult<FilialeInfo>>(RestPaths.filialeInfo, request)
      .then((response) => {
        if (response.data.success) {
          this.infoLoadState = LoadState.Completed
          this.filialeInfo = response.data.payload
        } else {
          this.infoLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.infoLoadState = LoadState.Error
      })
  }
}
